let timeout = 0

export const debounceTime = (callback, delay = 300) => {
  if (timeout) clearTimeout(timeout)

  timeout = setTimeout(() => callback(), delay)
}
